<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <div class="restaurants">
          <div class="row my-3">
            <h2 class="">{{ $t('users.title') }}</h2>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 mb-4">
              <div class="alert alert-danger" role="alert">
                {{ $t('pageIsDevelopment') }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-2 mb-4">
              <button
                  @click="openModalForAddUser"
                  class="btn btn-sm btn-outline-success px-3">{{ $t('users.add') }}</button>
            </div>
          </div>
          <div class="row">
            <div class="table-responsive-md">
              <table class="table table-hover table-users">
                <thead>
                  <tr>
                    <th scope="col">{{ $t('users.name') }}</th>
                    <th scope="col">{{ $t('users.phone') }}</th>
                    <th scope="col">{{ $t('users.email') }}</th>
                    <th scope="col">{{ $t('users.accessToRestaurants') }}</th>
                    <th scope="col">{{ $t('users.job') }}</th>
                    <th scope="col"> </th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Jon</td>
                  <td>+79093002210</td>
                  <td>Lychagin-Jon@gmail.com</td>
                  <td>
                    <div class="d-flex gap-2">
                      <span class="badge text-bg-warning">BurgerCompany</span>
                    </div>
                  </td>
                  <td>Manager</td>
                  <td>
                    <button class="btn btn-sm btn-outline-secondary p-1" style="line-height: 1rem">
                      <svg class="bi fs-4 delete-product-ico" width="1rem" height="1rem" fill="currentColor">
                        <use xlink:href="../assets/ico/bootstrap-icons.svg#pencil-fill"/>
                      </svg>
                    </button>
                  </td>
                </tr>
                  <tr>
                    <td>Karl</td>
                    <td>+79091230011</td>
                    <td>karl3001@gmail.com</td>
                    <td>
                      <div class="d-flex gap-2">
                        <span class="badge text-bg-warning">BurgerCompany</span>
                        <span class="badge text-bg-warning">WrapETC</span>
                      </div>
                    </td>
                    <td>Courier</td>
                    <td>
                      <button class="btn btn-sm btn-outline-secondary p-1" style="line-height: 1rem">
                        <svg class="bi fs-4 delete-product-ico" width="1rem" height="1rem" fill="currentColor">
                          <use xlink:href="../assets/ico/bootstrap-icons.svg#pencil-fill"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    modal add user-->
    <div class="modal fade" id="modalAddUser" tabindex="-1" aria-labelledby="modalAddUserLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalAddUserLabel">{{ $t('users.addUserTitle') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body row">
            <div class="col-12 col-md-6">
              <div class="mb-3">
                <label for="userName" class="form-label text-muted">{{ $t('users.name') }}</label>
                <input type="text" class="form-control" id="userName">
              </div>
              <div class="mb-3">
                <label for="userSurname" class="form-label text-muted">{{ $t('users.surname') }}</label>
                <input type="text" class="form-control" id="userSurname">
              </div>
              <div class="mb-3">
                <label for="userPhone" class="form-label text-muted">{{ $t('users.phone') }}</label>
                <input type="text" class="form-control" id="userPhone">
              </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <div class="mb-3">
                <label for="userJob" class="form-label text-muted">{{ $t('users.job') }}</label>
                <select class="form-select" id="userJob" aria-label="Job user select">
                  <option selected disabled>Select</option>
                  <option value="administrator">Director</option>
                  <option value="manager">Manager</option>
                  <option value="cook">Cook</option>
                  <option value="courier">Delivery</option>
                </select>
              </div>
              <div>
                <p class="mb-1 text-muted">{{ $t('users.accessToRestaurants') }}</p>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="burger-max" id="burgerMax">
                  <label class="form-check-label" for="burgerMax">Restaurant 1</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="burger-max" id="new1">
                  <label class="form-check-label" for="new1">Restaurant 2</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="cipa-v-dele" id="cipaVDele">
                  <label class="form-check-label" for="cipaVDele">Restaurant 3</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('users.close') }}</button>
            <button type="button" class="btn btn-success">{{ $t('users.save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMain from './modules/NavMain'
import MyBreadcrumb from './modules/Breadcrumb'
import {Modal} from "bootstrap";
export default {
  name: "Users",
  components: {NavMain, MyBreadcrumb},
  methods: {
    openModalForAddUser() {
      const optionModal = new Modal(document.querySelector('#modalAddUser'));
      optionModal.show();
    },
  }
}
</script>

<style scoped>

</style>
